import { render, staticRenderFns } from "./sector.vue?vue&type=template&id=4d79d82e&scoped=true&"
import script from "./sector.vue?vue&type=script&lang=js&"
export * from "./sector.vue?vue&type=script&lang=js&"
import style0 from "./sector.vue?vue&type=style&index=0&id=4d79d82e&prod&lang=less&scoped=true&"
import style1 from "./sector.vue?vue&type=style&index=1&id=4d79d82e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d79d82e",
  null
  
)

export default component.exports